module.exports = __webpack_public_path__ + "img/testo_liquido.a59cf383.svg";